import { SiteItemData } from "../../../../interfaces";
import * as classNames from "classnames"
import { disablePageRefresh, enablePageRefresh } from "../../../../siteWidgets/siteWidgetUtils";
import { VerticalVideoOverlayPlayer } from "../../../verticalVideoOverlayPlayer/verticalVideoOverlayPlayer";
import { categoryObj } from "../../../radionas/verticalVideoGallery/components/radionasVideoGalleryVerticalComponenta"

interface MultiArticleWeekendVideoItemProps {
    isLTR: boolean
    index: number
    domain: string
    title: string
    category: categoryObj
    videoItem: SiteItemData & { hidePrerollAds?: boolean, prerollIndex?: number }
    resourceId: string
    videoCaption: string
    posterSrc: string
    promoPath: string
    duration: number
    languageCode: string
    isSmallItem: boolean
    isMobile?: boolean
    showPrerollAds?: boolean
    isTitleVisible?: boolean
    isSubTitleVisible?: boolean
    isAuthor?:boolean
}

interface MultiArticleWeekendVideoItemState {
    isMouseHover: boolean
    isOverlayOpen: boolean
    isItemIntoView: boolean
    isPromoPlayed: boolean
}

export class MultiArticleWeekendVideoItem extends React.Component<MultiArticleWeekendVideoItemProps, MultiArticleWeekendVideoItemState>{
    public static siteScriptName = "MultiArticleWeekendVideoItem";

    constructor(props) {
        super(props);
        this.state = {
            isMouseHover: false,
            isOverlayOpen: false,
            isItemIntoView: false,
            isPromoPlayed: false
        }
    }

    private videoRef;
    private slotRef;
    private intersectionObserver: IntersectionObserver;

    private initIntersectionObserver = () => {
        this.intersectionObserver = new IntersectionObserver(entry => {
            entry[0].isIntersecting ? this.onVideoIntersectViewport() : this.onVideoLeaveViewport();
        }, { threshold: 0.8 })
        this.intersectionObserver.observe(this.slotRef);
    }

    componentDidMount() {
        this.props.isMobile && this.initIntersectionObserver();
    }

    componentWillUnmount() {
        this.intersectionObserver && this.intersectionObserver.disconnect();
    }

    private onVideoIntersectViewport = () => {
        this.setState({ isItemIntoView: true });
        if (this.videoRef) this.videoRef.play();
    }

    private onVideoLeaveViewport = () => {
        this.setState({ isItemIntoView: false, isPromoPlayed: false });
        if (this.videoRef) this.videoRef.pause();
    }

    private onMouseHover = () => {
        this.setState({ isMouseHover: true });
        if (this.videoRef) this.videoRef.play();
    }

    private onMouseLeave = () => {
        this.setState({ isMouseHover: false });
        if (this.videoRef) this.videoRef.pause();
    }

    private openVideoDisplayView = () => {
        this.setState({ isOverlayOpen: true });
        disablePageRefresh();
    }

    private closeVideoDisplayView = () => {
        this.setState({ isOverlayOpen: false });
        enablePageRefresh();
    }

    private formatSecondsToMinutes = (seconds: number) => {
        const minutes = Math.floor(seconds / 60).toString().padStart(2, "0");
        const newSeconds = (seconds % 60).toString().padStart(2, "0");
        return `${minutes}:${newSeconds}`;
    }

    private promoEnded = () => {
        this.setState({ isPromoPlayed: true });
    }

    public render() {
        const { isMouseHover, isOverlayOpen, isItemIntoView, isPromoPlayed } = this.state;
        const { index, title, isTitleVisible, isAuthor, posterSrc, promoPath, duration, domain, videoItem, languageCode,
             showPrerollAds, isSmallItem, isMobile, isLTR, category, isSubTitleVisible } = this.props
        const shouldDisplayPromo = promoPath && isMobile ? isItemIntoView && !isPromoPlayed && index === 1 : isMouseHover;
        return (
            <>
                <div className="slotView video-item" onClick={this.openVideoDisplayView} onMouseEnter={!isMobile && this.onMouseHover} onMouseLeave={!isMobile && this.onMouseLeave} ref={ref => this.slotRef = ref}>
                    <div className="mediaArea" data-tb-thumbnail>
                        {shouldDisplayPromo ?
                            <video
                                muted
                                autoPlay
                                src={promoPath}
                                loop={!isMobile}
                                poster={posterSrc}
                                className="promoVideo"
                                onEnded={this.promoEnded}
                                ref={ref => this.videoRef = ref}
                            />
                            :
                            <img src={posterSrc} alt="" />
                        }
                    </div>

                    {!shouldDisplayPromo &&
                        <div className={`textArea ${isAuthor ? "withAuthor" : ""}`}>
                            {isTitleVisible &&
                                <div className={classNames("slotTitle", { "withWidth": title.length === 0, "medium": !isSmallItem, "small": isSmallItem })}>
                                    {title}
                                </div>
                            }

                            <div className="videoDuration">
                                <span>{this.formatSecondsToMinutes(Math.round(duration))}</span>
                                <span className="durationLogo"></span>
                            </div>
                        </div>
                    }
                </div>

                <VerticalVideoOverlayPlayer
                    isLTR={isLTR}
                    index={index}
                    domain={domain}
                    isMobile={isMobile}
                    category={category}
                    videoItems={videoItem}
                    languageCode={languageCode}
                    isSingleVideoDisplay={true}
                    isOverlayOpen={isOverlayOpen}
                    showPrerollAds={showPrerollAds}
                    isTitleVisible={isTitleVisible}
                    isSubTitleVisible={isSubTitleVisible}
                    onVideoOverlayClose={this.closeVideoDisplayView}
                />
            </>
        )
    }
}